import React from 'react'
import HowStartpageWorks from '../how-startpage-works'

const HowStartpageWorksEn = () => {
    return <HowStartpageWorks languageCode="en" />
}

export default HowStartpageWorksEn
